import React from 'react';
import { Container, Card, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { ToastContainer } from 'react-toastify';
import { useParams } from "react-router-dom";
import Api from "../../Api/Api.js";
import { API as api, username } from "../../API";
import Navbar from "../Navbar";
// import { isAuthenticated } from "../../Auth/isAuthenticated.js";

import axios from "axios";
import { isAutheticated } from "../auth/authhelper.js";
import { toastError } from "../../utilis/toast.js";



const PaymentType = () => {

  // const { username } = useParams();
  const [about, setAbout] = useState();
  const [subscription, setSubscription] = useState(null);
  const { token } = isAutheticated();



  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getUserAbout(username);
      console.log(data);
      setAbout(data);
      localStorage.setItem("userId", data._id);
    };
    getData();
  }, [username]);

  useEffect(() => {
    const checkSubscription = async () => {
      if (!token) {
        setSubscription(false)
        return;
      } else {
        try {
          const now = new Date()
          console.log("requesting user data from server");
          const response = await axios.get(`${api}/api/client/${username}/checkSubscription`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log(response.data.data)
          if (response.data.data) {
            const end = new Date(response.data.data.subEnd)
            if (end >= now) {
              setSubscription(response.data.data);
            }
          } else {
            setSubscription(response.data.data);
          }
        } catch (err) {
          console.log(err);
          setSubscription(false)
        }
      }
    };
    checkSubscription()
  }, [token])

  const makePayment = async (userid, subscriptiontype, stripe) => {
    console.log("hello");
    let data
    try {
      data = await fetch(`${api}/api/client/stripe/create-checkout-session`, {
        headers: {
          // Authorization: `Bearer ${localStorage.getItem(token)}`,
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        method: "post",
        body: JSON.stringify({
          userID: userid,
          paymentType: subscriptiontype,
        }),
      });

      const session = await data.json();
      localStorage.setItem("sessionStripeId", JSON.stringify(session));
      console.log(session, "this is session");
      stripe
        .redirectToCheckout({
          sessionId: session.id,
        })
        .then(function (result) {
          console.log(result);
        });
    } catch (e) {
      console.log(e)
      toastError(e?.response?.data?.message);
    }
  };

  const payMounthly = () => {
    var stripe = window.Stripe(
      "pk_test_51KqBFQSIufXluQVzbMQ8wyfwrCly3bBWSnBIWEhfdBiMKG8bmeZgui4NcmBsxvrpr9dWdZD4IfDk9a7UFd0QfNcQ00lodshmrM",
      {
        stripeAccount: about.payments.stripe.id,
      }
    );
    makePayment(about._id, "monthly", stripe);
  };
  const payYearly = () => {
    var stripe = window.Stripe(
      "pk_test_51KqBFQSIufXluQVzbMQ8wyfwrCly3bBWSnBIWEhfdBiMKG8bmeZgui4NcmBsxvrpr9dWdZD4IfDk9a7UFd0QfNcQ00lodshmrM",
      {
        stripeAccount: about.payments.stripe.id,
      }
    );
    makePayment(about._id, "yearly", stripe);
  };


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "4rem",
      }}
    >
      <Navbar style={{ position: "fixed" }} />
      <div
        style={{
          marginTop: "8rem",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        {/* {settings.map((plan) => { */}
        {/* return ( */}
        {about?.feesPerMonth && < Card style={{ textAlign: "center", width: "18rem" }}>
          <Card.Body>
            <Card.Title
              style={{
                padding: "2rem 0",
                background: "green",
                color: "white",
                fontWeight: "bold",
              }}
            >
              Monthly{subscription && subscription.subType === "monthly" && " (Active)"}
            </Card.Title>
            <Card.Title
              style={{
                margin: "2rem 0",
                color: "black",
                fontWeight: "bold",
              }}
            >
              {about.settings.currency}  {about.feesPerMonth}
            </Card.Title>
            {subscription && subscription.subType === "monthly" && <Card.Body className="p-0 text-success">
              <div>
                <b>Subscription Start = {new Date(subscription?.subStart).toDateString()}</b>
              </div>
              <b>Subscription End = {new Date(subscription?.subEnd).toDateString()}</b>
            </Card.Body>}
            <Button variant="primary" style={{ margin: "1rem 0" }}
              // disabled={subscription ? (subscription) : subscription === null}
              onClick={payMounthly}
            // onClick={() => {
            // history.push(`/${username}/search`);
            // history.push(`/payment`);
            // }}
            >
              {subscription ? "Upgrade Now" : "Subscribe Now"}
            </Button>
          </Card.Body>
        </Card>}
        {about?.feesPerYear && <Card style={{ textAlign: "center", width: "18rem" }}>
          <Card.Body>
            <Card.Title
              style={{
                padding: "2rem 0",
                background: "green",
                color: "white",
                fontWeight: "bold",
              }}
            >
              Yearly{subscription && subscription.subType === "yearly" && " (Active)"}
            </Card.Title>
            <Card.Title
              style={{
                margin: "2rem 0",
                color: "black",
                fontWeight: "bold",
              }}
            >
              {about.settings.currency} {about.feesPerYear}
            </Card.Title>
            {subscription && subscription.subType === "yearly" && <Card.Body className="p-0 text-success">
              <div>
                <b>Subscription Start = {new Date(subscription?.subStart).toDateString()}</b>
              </div>
              <b>Subscription End = {new Date(subscription?.subEnd).toDateString()}</b>
            </Card.Body>}
            <Button variant="primary" style={{ margin: "1rem 0" }}
              // disabled={subscription ? (subscription && subscription.subType === "yearly") : subscription === null}
              onClick={payYearly}
            // onClick={() => {
            //   // history.push(`/${username}/search`);
            //   history.push(`/payment`);
            // }}
            >
              {subscription ? "Upgrade Now" : "Subscribe Now"}
            </Button>
          </Card.Body>
        </Card>}

        {(about?.feesPerMonth === 0 && about?.feesPerYear === 0) && < Card style={{ textAlign: "center", width: "18rem" }}>
          <Card.Body>
            <Card.Title
              style={{
                padding: "2rem 0",
                background: "green",
                color: "white",
                fontWeight: "bold",
              }}
            >
              Free
            </Card.Title>
            <Card.Title
              style={{
                margin: "2rem 0",
                color: "black",
                fontWeight: "bold",
              }}
            >
              {about.settings.currency}  {about.feesPerMonth}
            </Card.Title>

          </Card.Body>
        </Card>}

        {/* ); */}
        {/* })} */}
      </div>
      <ToastContainer position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div >
  );
};
export default PaymentType;
// {/* <Container
//   className="d-inline-flex w-100 justify-content-center align-items-center"
//   style={{ height: "100vh" }}
// >
//   <Navbar />
//   {about && (
//     <Card
//       style={{ width: "25rem", height: "18em" }}
//       className="text-center m-2"
//     >
//       <Card.Body>
//         <Card.Title>
//           {about.firstName} {about.lastName}
//         </Card.Title>
//         <Card.Body>
//           <div>
//             <h4 className="text-center text- m-3">Make Payment</h4>
//             <div className="d-flex flex-wrap justify-content-between">
//               <div className="d-flex flex-wrap flex-column mt-4">
//                 <p>Monthly Subscription</p>

//                 <Button variant="outline-info" onClick={payMounthly}>
//                   {/* {about.feesPerMonth} */}
//                   <span className="text-dark fs-6 mt-3">
//                     {/* {about.settings.currency} */}
//                     149
//                   </span>
//                 </Button >
//               </div >
//               <div className="d-flex flex-wrap flex-column mt-4">
//                 <p>Yearly Subscription</p>
//                 <Button
//                   variant="outline-info"
//                   onClick={payYearly}
//                   className=""
//                 >
//                   {/* {about.feesPerYear} */}
//                   999
//                   <span
//                     className="text-dark fs-6 mt-3"
//                     style={{ fontSize: "20px" }}
//                   >
//                     {about.settings.currency}
//                   </span>
//                 </Button>
//               </div>
//             </div >
//           </div >
//           <br />
//         </Card.Body >
//       </Card.Body >
//     </Card >
//   )}
// </Container >  */}